<script lang="ts">
  import ProductCard from '$lib/components/product/ProductCard.svelte'
	import { is_set_array } from "$lib/js/helpers";
  import { t } from 'svelte-i18n-lingui';
  import type { BaseProduct, FullProduct } from '$lib/js/elasticsearch/types';

  interface Props {
    products: (BaseProduct | FullProduct)[];
    allResults?: boolean;
    type?: string; // '' | 'search'
  }

  let { products = $bindable(), allResults = $bindable(false), type = "" }: Props = $props();
</script>


{#key products}
  {#if is_set_array(products)}
    <div class="category__products-wrapper">
      {#each products as product}
        {#if product.url_key !== undefined}
          <div class="product-card {type}">
            <ProductCard product={product} {type}/>
          </div>
        {/if}
      {/each}
    </div>
  {:else}
    <div class="category__no-products">
      <p>{$t`No results for the current selection`}</p>
    </div>
  {/if}

  {#if allResults === true && is_set_array(products) && products.length > 0}
    <div class="all-results">
      <p>{$t`No more results to show`}</p>
    </div>
  {/if}
{/key}


<style lang="scss">
  .category {
    &__products-wrapper {
      display: flex;
      flex-wrap: wrap;
      margin: 0 0 30px;

      @media (min-width: 450px) {
        margin: 0 -8px 30px;
      }

      @media (min-width: 769px) {
        margin: 0 -20px 50px -8px;
      }

      @media (min-width: 1500px) {
        margin: 0 -8px 50px;
      }
    }

    &__no-products {
      p {
        padding: 30px;
        background: var(--grey);
      }
    }
  }

  .product-card {
    margin: 0 0 12px 0;
    width: 100%;

    @media (min-width: 450px) {
      margin: 8px;
      width: calc(50% - 16px);
    }

    @media (min-width: 769px) {
      width: calc(33.3% - 20px);
    }


    @media (min-width: 1500px) {
      width: calc(25% - 16px);
    }

		&.search {
			margin: 6px;
			width: calc(50% - 12px);

			@media (min-width: 450px) {
				margin: 6px;
				width: calc(50% - 12px);
			}

			@media (min-width: 769px) {
				margin: 8px;
				width: calc(33.3% - 20px);
    	}

			@media (min-width: 1200px) {
				width: calc(25% - 16px);
			}

			@media (min-width: 1500px) {
				width: calc(20% - 16px);
			}

			@media (min-width: 2000px) {
				width: calc(16.6% - 16px);
			}
		}
  }

  .all-results{
    p {
      padding: 30px;
      background: var(--grey);
    }
  }
</style>
